export default __webpack_public_path__ + "static/media/21.73156c18.png";